/**
 *
 * UserFemaleBadge
 *
 */

import React, { memo } from 'react';
import styled from 'styled-components';

import UserFemaleIcon from '../../../../assets/v2/UserFemaleIcon';
import { COLORS } from '../../../../theme';
import Badge from '..';

const StyledBadge = styled(Badge)`
  &.MuiChip-root {
    color: ${COLORS.orchidDark};
    background: ${COLORS.orchidLight};
    border-color: ${COLORS.orchid};
  }

  && .MuiSvgIcon-root {
    path {
      fill: ${COLORS.orchid};
    }
  }
`;

function UserFemaleBadge(props) {
  return <StyledBadge label="Female" icon={<UserFemaleIcon />} {...props} />;
}

export default memo(UserFemaleBadge);
